import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { RxComposite } from '../model/rx-composite';
import { TipType } from '@nrwl/rx-models';
import { CommonModule } from '@angular/common';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTooltipModule } from '@nrwl/rx-tooltip';
import { RxButtonModule } from '@nrwl/rx-button';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RxTipModule } from '@nrwl/rx-tip';

export enum UploadStatus {
  Uploading = 1,
  Uploaded = 2,
  Failed = 3,
}

export class UploadPaidTemplateModel {
  id: number;
  name: string;
  data: string;
  status: number;
}

@Component({
  selector: 'nrwl-rx-upload-paid-composite',
  templateUrl: './rx-upload-paid-composite.component.html',
  styleUrls: ['./rx-upload-paid-composite.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxIconModule,
    RxTooltipModule,
    RxButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    RxTipModule,
  ],
})
export class RxUploadPaidCompositeComponent extends RxComposite implements OnInit {
  @ViewChild('input') input: ElementRef;

  formData;
  currentIndex: number;

  public tipType = TipType;
  public filesToUpload: UploadPaidTemplateModel[] = [];
  public uploadBrowser: any[] = [];

  public uploadStatus = UploadStatus;

  control = new FormGroup({
    checkbox1: new FormControl('', [Validators.required]),
    checkbox2: new FormControl('', [Validators.required]),
    checkbox3: new FormControl('', [Validators.required]),
  });

  constructor() {
    super();
  }

  ngOnInit() {
    this.payload.filesToUpload = this.filesToUpload;
  }

  getFiles(): Observable<any[]> {
    return of(this.filesToUpload);
  }

  onActive() {
    this.input.nativeElement.click();
  }

  onChange(e) {
    if (e.target.files && e.target.files.length > 0) {
      this.getFilesFromInput(e.target.files);
    }
    e.preventDefault();
    e.stopPropagation();
  }

  onDrop(event) {
    event.preventDefault();
    this.getFilesFromInput(event.dataTransfer.files);
  }
  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  getFilesFromInput(files) {
    for (let i = 0; i < files.length; i++) {
      // TODO: Hard limit Files
      if (this.filesToUpload.length < 5) {
        this.setupReader(files[i]);
      }
    }
  }

  setupReader(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {
      const item = new UploadPaidTemplateModel();
      const b64Content = e.target.result;
      const block = b64Content.split(';');
      const contentType = block[0].split(':')[1] || '';
      const b64Data = block[1].split(',')[1];
      item.name = file.name;
      item.data = b64Data;
      item.status = 0;
      this.filesToUpload.push(item);
    };
  }

  trackByFn(i: number) {
    return i;
  }

  removeFile(i: number) {
    this.filesToUpload.splice(i, 1);
  }
}
